import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { IoCall } from "react-icons/io5";
import ReviewsModal from "../common/modals/ReviewsModal";

function SideContactButtons() {
  return (
    <>
      <div className="sideContect_buttons">
        <a href="tel:+917535051511" className="call_btn"><IoCall /></a>
        <a href="https://wa.me/917535051511?text=Hi,%20I%20want%20to%20book%20a%20cab"
          target="_blank" rel="noreferrer" className="whatsapp_btn"><FontAwesomeIcon icon={faWhatsapp} /></a>
      </div>
      <ReviewsModal />
    </>
  );
}


export default SideContactButtons;
